export default {
  haveRead: '本人已阅读，知悉及明白「内部转账相关费用明细」',
  fundTransferTipsTitle: '内部转账相关费用明细',
  fundTransferTips: {
    exchangePriceDifferenceCompany: {
      title: '兑换差价 (本公司收取)',
      tips: '如内部转账间之交易账户结算货币是不同,本公司会以本公司适用的银行汇率兑换成存款账户货币后进行存款, 过程中有可能产生兑换差价。'
    }
  },
  placeholderAmount: '请输入金额',
  maxText: '最大可转'
}
